import { isXmlStatedReceipt } from '@/modules/receipt/form/receipt-document-totals'

// FLAG:useDocuAi — WHEN the line items of a receipt are the DOCUMENT's and must not be edited.
//
// True for an XML e-invoice on BOTH surfaces that show its lines: the review ("Prüfung") and the
// booked receipt that came out of that review. Until 2026-09-21 only the review locked them — the
// gate hung on `isDocumentInvoiceReviewMode`, which the expense/revenue form never sets, so saving
// an XML review and reopening the expense offered editable amounts, VAT rates and descriptions
// again. That surface is the riskier of the two: the review save restores the mapped values
// server-side (xmlLockedFields.ts), while expenseService/update.js recomputes the positions from
// whatever the client sends.
//
// `enabled` is the STRUCTURAL flag gate, the same one hasStatedReceiptTotals carries for the same
// reason (omxweb review finding F22.1): the data condition below is pure record content, so a
// tenant whose useDocuAi was switched off would still meet it through documents reviewed earlier.
// Callers pass `isDocumentInvoiceReviewMode || positionReviewTools`, both false flag-OFF, so the
// line-item list keeps its legacy render.
//
// NOT covered here on purpose: the tax category. It is our bookkeeping assignment, it is not in
// the document, and it stays selectable on every XML line (that is what the review is for).
export const areReceiptPositionsXmlLocked = ({
  enabled,
  documentReviewDetails,
  data,
}: {
  enabled?: boolean
  documentReviewDetails?: Parameters<typeof isXmlStatedReceipt>[0]
  data?: Parameters<typeof isXmlStatedReceipt>[1]
}): boolean => !!enabled && isXmlStatedReceipt(documentReviewDetails, data)
